import EmbedPre from "./Components/EmbedPre";

const appComponentsMap = {
  pre: EmbedPre,
};

export default appComponentsMap;
